import {useQuery} from "@tanstack/react-query";

import {fetchRoles, fetchRolesByOwner} from "../../services/network/role-api";
import {FEEDBACK_ENDPOINTS, RECOMMENDATION_ENDPOINTS, ROLE_ENDPOINTS} from "../../services/network/endpoints";
import {RecommendationsApi} from "../../services/network/recommendation-api";
import {FeedbackApi} from "../../services/network/feedback-api";

export function useFetchFeedback(feedbackId: string | undefined) {
    const {data, error, isLoading} = useQuery({
        queryKey: [FEEDBACK_ENDPOINTS.GET, feedbackId],
        queryFn: () => FeedbackApi.fetchFeedback(feedbackId),
        enabled: Boolean(feedbackId),
    });

    return {
        fbsData: data?.data,
        fbsError: error,
        fbsIsLoading: isLoading,
    };
}
